export default __webpack_public_path__ + "static/puzzle-e7ada57e0c959b0c7fc065e36229d258.svg";